// src/composables/usePracticeSession.js
import { ref, computed } from 'vue';
import { useProgressStore } from '@/stores/progressStore';

// For now: simple demo question generator.
// Later: replace with API call to MongoDB
function getDummyQuestions(sectionGroupId) {
  const bank = {
    WS_PV_PLACEVALUE: [
      { id: 'pv1', text: 'What is the value of 7 in 7,352?', correct: '1000' },
      { id: 'pv2', text: 'Write 40,503 in words.', correct: 'forty thousand five hundred and three' }
    ],
    WS_PV_ROUNDING: [
      { id: 'rd1', text: 'Round 4,583 to the nearest hundred.', correct: '4600' },
      { id: 'rd2', text: 'Round 9,941 to the nearest thousand.', correct: '10000' }
    ],
    default: [
      { id: 'q1', text: '5 + 7 = ?', correct: '12' },
      { id: 'q2', text: '10 × 3 = ?', correct: '30' }
    ]
  };

  return bank[sectionGroupId] || bank.default;
}

export function usePracticeSession(sectionGroupId) {
  const progressStore = useProgressStore();

  // Load dummy questions for now
  const questions = ref(getDummyQuestions(sectionGroupId));

  const currentIndex = ref(0);
  const completed = ref(false);
  const lastResult = ref(null);
  const attempts = ref(0);

  const current = computed(() => questions.value[currentIndex.value]);

  function submitAnswer(answer) {
    if (!current.value) return;

    const correct =
      String(answer).trim().toLowerCase() ===
      String(current.value.correct).trim().toLowerCase();

    lastResult.value = correct ? 'correct' : 'wrong';
    attempts.value += 1;

    // Update mastery store
    progressStore.updateProgress(sectionGroupId, correct);

    return correct;
  }

  function nextQuestion() {
    if (currentIndex.value < questions.value.length - 1) {
      currentIndex.value += 1;
      lastResult.value = null;
    } else {
      completed.value = true;
    }
  }

  const mastery = computed(() => {
    const p = progressStore.progress[sectionGroupId];
    return p ? p.accuracy : 0;
  });

  return {
    questions,
    current,
    currentIndex,
    completed,
    lastResult,
    attempts,
    mastery,
    submitAnswer,
    nextQuestion
  };
}
